import { TableActionMenu, UuidFilterInput, type TableActionItem } from '@/components/shared';
import type { PricingTier } from '../types';

const PRICING_TIER_OPTIONS: Array<{ value: PricingTier; label: string }> = [
  { value: 'free_1', label: 'Free 1' },
  { value: 'payg_1', label: 'Pay as you go 1' },
  { value: 'ent_1', label: 'Enterprise 1' },
];

export interface OrganizationsFiltersProps {
  pricingTier: PricingTier | '';
  organizationId: string;
  owner: string;
  actions?: TableActionItem[];
  onPricingTierChange: (pricingTier: PricingTier | '') => void;
  onOrganizationIdChange: (value: string) => void;
  onOwnerChange: (value: string) => void;
}

export function OrganizationsFilters({
  pricingTier,
  organizationId,
  owner,
  actions = [],
  onPricingTierChange,
  onOrganizationIdChange,
  onOwnerChange,
}: OrganizationsFiltersProps) {
  return (
    <div className="flex flex-wrap items-stretch gap-3 border-b border-neutral-200 bg-neutral-50 px-5 py-4 sm:items-end">
      <label className="flex w-full min-w-0 flex-col gap-1 text-small font-medium text-neutral-700 sm:w-auto sm:min-w-[170px]">
        Pricing tier
        <select
          value={pricingTier}
          onChange={(event) => onPricingTierChange(event.target.value as PricingTier | '')}
          className="h-10 rounded-lg border border-neutral-200 bg-white px-3 text-body text-neutral-900"
        >
          <option value="">All tiers</option>
          {PRICING_TIER_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </label>

      <UuidFilterInput
        label="Organization"
        value={organizationId}
        onChange={onOrganizationIdChange}
        placeholder="Organization UUID"
        className="flex w-full min-w-0 flex-col gap-1 text-small font-medium text-neutral-700 sm:w-auto sm:min-w-[260px]"
      />

      <label className="flex w-full min-w-0 flex-col gap-1 text-small font-medium text-neutral-700 sm:w-auto sm:min-w-[260px]">
        Owner
        <input
          type="text"
          value={owner}
          onChange={(event) => onOwnerChange(event.target.value.trim())}
          placeholder="User UUID or email"
          className="h-10 rounded-lg border border-neutral-200 bg-white px-3 text-body text-neutral-900"
        />
      </label>

      {actions.length > 0 && (
        <div className="flex w-full justify-end sm:ml-auto sm:w-auto">
          <TableActionMenu actions={actions} label="Organization table actions" />
        </div>
      )}
    </div>
  );
}
